import React, { useState, useEffect } from "react";
import Select, { StylesConfig } from "react-select";
import { API_BASE_URL } from "../../../config/serverApiConfig";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import chroma from "chroma-js";
import {
    ColourOption,
    languageOptions,
    statusOptions
} from "../../../Selecteddata/data";

const CandidateFilters = ({ onFilterChange }) => {
    const location = useLocation();
    const status = location.state?.status || null;

    const [dlOptions, setDlOptions] = useState([{
        value: "true",
        label: "Yes",
        color: "#FF8B00",
    }, {
        value: "false",
        label: "No",
        color: "#FF8B00",
    }]);
    const [professions, setProfessions] = useState([
        { jobName: "", associatedSector: "", _id: "" },
    ]);
    const [owners, setOwners] = useState([]);
    const [ownersOptions, setOwnersOptions] = useState([]);
    const [sectors, setSectors] = useState([]);
    const [sectorsOptions, setSectorsOptions] = useState([]);
    const [haveLicence, setHaveLicence] = useState(false);
    const [licenceValue, setLicenceValue] = useState(null);
    const [haveLanguage, setHaveLanguage] = useState(false);
    const [languageValue, setLanguageValue] = useState(null);
    const [haveOwner, setHaveOwner] = useState(false);
    const [ownerValue, setOwnerValue] = useState(null);
    const [haveStatus, setHaveStatus] = useState(status ? true : false);
    const [statusValue, setStatusValue] = useState(status ? status.charAt(0).toUpperCase() + status.slice(1) : null);
    const [haveSector, setHaveSector] = useState(false);
    const [sectorValue, setSectorValue] = useState(null);
    const [haveProfession, setHaveProfession] = useState(false);
    const [professionValue, setProfessionValue] = useState(null);
    const [professionOptions, setProfessionOptions] = useState([]);
    const [haveKeyword, setHaveKeyword] = useState(false);

    const colourStyles: StylesConfig<ColourOption, true> = {
        control: (styles) => ({ ...styles, backgroundColor: "white", padding: '5px', borderRadius: '20px', cursor: 'pointer' }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = chroma(data.color);
            return {
                ...styles,
                backgroundColor: isDisabled
                    ? undefined
                    : isSelected
                        ? data.color
                        : isFocused
                            ? color.alpha(0.1).css()
                            : undefined,
                color: isDisabled
                    ? "#ccc"
                    : isSelected
                        ? chroma.contrast(color, "white") > 2
                            ? "white"
                            : "black"
                        : data.color,
                cursor: isDisabled ? "not-allowed" : "default",

                ":active": {
                    ...styles[":active"],
                    backgroundColor: !isDisabled
                        ? isSelected
                            ? data.color
                            : color.alpha(0.3).css()
                        : undefined,
                },
            };
        },
        multiValue: (styles, { data }) => {
            const color = chroma(data.color);
            return {
                ...styles,
                backgroundColor: color.alpha(0.1).css(),
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: data.color,
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: data.color,
            ":hover": {
                backgroundColor: data.color,
                color: "white",
            },
        }),
    };

    const fetchOwners = async () => {
        return await fetch(API_BASE_URL + `allusers`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
            },
        })
            .then((red) => red.json())
            .then((resData) => resData)
            .catch((err) => err);
    };

    const fetchActivitySectors = async () => {
        return await fetch(API_BASE_URL + "fetchAllSectors", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
            },
        })
            .then((resp) => resp.json())
            .then((respData) => respData)
            .catch((err) => err);
    };

    const fetchAllJobs = async (sector: string) => {
        return await fetch(API_BASE_URL + `fetchAllJobs/?sector=${sector}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
            },
        })
            .then((resD) => resD.json())
            .then((reD) => reD)
            .catch((err) => err);
    };

    const fetchProfessionsForASector = async (sector: string) => {
        if (sector) {
            await fetchAllJobs(sector)
                .then((data) => {
                    setProfessions([...data.data]);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    useEffect(() => {
        if (!owners.length) {
            fetchOwners()
                .then((ownersData) => {
                    setOwners([...ownersData.data])
                })
                .catch(err => console.log(err));
        }
        if (ownersOptions.length === 0) {
            const ownersOps = owners.map((owner) => {
                return {
                    value: owner.username,
                    label: owner.username,
                    color: "#FF8B00",
                };
            })

            setOwnersOptions([...ownersOps]);
        }
    }, [owners]);

    useEffect(() => {
        if (!sectors.length) {
            fetchActivitySectors()
                .then((sectorsData) => {
                    setSectors([...sectorsData.data])
                })
                .catch(err => console.log(err));
        }
        if (sectorsOptions.length === 0) {
            const sectorsOps = sectors.map((sector) => {
                return {
                    value: sector.sectorName,
                    label: sector.sectorName,
                    color: "#FF8B00",
                };
            })

            setSectorsOptions([...sectorsOps]);
        }
    }, [sectors]);

    useEffect(() => {
        let professionResults = !professions.length
            ? []
            : professions.map((profession) => ({
                value: profession.jobName,
                label: profession.jobName,
                color: "#FF8B00",
            }));

        setProfessionOptions([...professionResults]);
    }, [professions]);

    useEffect(() => {
        if (status) {
            onFilterChange('candidatStatus', status.charAt(0).toUpperCase() + status.slice(1));
        }
    }, [status]);

    const handleDLChange = (selectedOption) => {
        setHaveLicence(true);
        setLicenceValue(selectedOption?.value);
        onFilterChange('candidatLicensePermis', selectedOption?.value);
    };

    const handleLanguageChange = (selectedOption) => {
        if (!selectedOption.length) {
            setHaveLanguage(false);
            setLanguageValue([]);
            onFilterChange('candidatLanguages', null);
            return;
        }

        const arr = selectedOption.map((el) => el.value);

        setHaveLanguage(true);
        setLanguageValue(arr);
        onFilterChange('candidatLanguages', arr);
    };

    const handleOwnerChange = (selectedOption) => {
        if (!selectedOption.length) {
            setHaveOwner(false);
            setOwnerValue([]);
            onFilterChange('enteredBy', null);
            return;
        }

        const arr = selectedOption.map((el) => el.value);

        setHaveOwner(true);
        setOwnerValue(arr);
        onFilterChange('enteredBy', arr);
    };

    const handleStatusChange = (selectedOption) => {
        setHaveStatus(true);
        setStatusValue(selectedOption?.value);
        onFilterChange('candidatStatus', selectedOption?.value);
    };

    const handleSectorChange = async (selectedOption) => {
        setProfessions([]);

        if (selectedOption?.value !== "") {
            let sectorField = selectedOption?.value;
            setHaveSector(true);
            setSectorValue(sectorField);
            onFilterChange('candidatActivitySector', sectorField);
            await fetchProfessionsForASector(sectorField);
        }
    };

    const handleProfessionChange = (selectedOption) => {
        if (!selectedOption.length) {
            setHaveProfession(false);
            setProfessionValue([]);
            onFilterChange('candidatJob', null);
            return;
        }

        const arr = selectedOption.map((el) => el.value);
        setHaveProfession(true);
        setProfessionValue(arr);
        onFilterChange('candidatJob', arr);
    };

    const resetDrivingLicence = () => {
        setHaveLicence(false);
        setLicenceValue(null);
        onFilterChange('candidatLicensePermis', null);
    }

    const resetLanguage = () => {
        setHaveLanguage(false);
        setLanguageValue([]);
        onFilterChange('candidatLanguages', null);
    }

    const resetOwner = () => {
        setHaveOwner(false);
        setOwnerValue([]);
        onFilterChange('enteredBy', null);
    }

    const resetKeyword = () => {
        setHaveKeyword(false);
    }

    const resetStatus = () => {
        setHaveStatus(false);
        setStatusValue(null);
        onFilterChange('candidatStatus', null);
    }

    const resetSector = () => {
        setHaveSector(false);
        setSectorValue(null);
        setHaveProfession(false);
        setProfessionValue(null);
        setProfessions([]);
        onFilterChange('candidatActivitySector', null);
        onFilterChange('candidatJob', null);
    }

    const resetProfession = () => {
        setHaveProfession(false);
        setProfessionValue(null);
        onFilterChange('candidatJob', null);
    }

    return (
        <div className="tw-flex tw-gap-2 tw-flex-wrap tw-bg-white tw-py-4 tw-rounded-xl tw-shadow-xl tw-mb-4">
            <div className="tw-flex tw-space-x-4 tw-justify-around tw-items-center tw-w-full">
                <div className="driver-license-filter tw-w-full">
                    <div className="tw-flex tw-justify-around tw-items-center">
                        <label className="Form-styling tw-mb-0">Filter By Driver Licence</label>

                        {haveLicence && (
                            <button
                                onClick={resetDrivingLicence}
                                className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xl tw-text-red-500"
                            >
                                ✖
                            </button>
                        )}
                    </div>
                    <Select
                        options={dlOptions}
                        value={dlOptions.filter((option) => {
                            return option.value === licenceValue
                        })}
                        onChange={handleDLChange}
                        styles={colourStyles}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        closeMenuOnSelect={true}
                        placeholder="Have Licence ?"
                    />
                </div>

                <div className="user-status-filter tw-w-full">
                    <div className="tw-flex tw-justify-around tw-items-center">
                        <label className="Form-styling tw-mb-0">Filter By Status</label>

                        {haveStatus && (
                            <button
                                onClick={resetStatus}
                                className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xl tw-text-red-500"
                            >
                                ✖
                            </button>
                        )}
                    </div>

                    <Select
                        options={statusOptions}
                        value={statusOptions.filter((option) => {
                            return option.value === statusValue
                        })}
                        onChange={handleStatusChange}
                        styles={colourStyles}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        closeMenuOnSelect={true}
                        placeholder="Select Status"
                    />
                </div>

                <div className="job-sector-filter tw-w-full">
                    <div className="tw-flex tw-justify-around tw-items-center">
                        <label className="Form-styling tw-mb-0">Filter By Sector</label>

                        {haveSector && (
                            <button
                                onClick={resetSector}
                                className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xl tw-text-red-500"
                            >
                                ✖
                            </button>
                        )}
                    </div>

                    <Select
                        options={sectorsOptions}
                        value={sectorsOptions.filter((option) => {
                            return option.value === sectorValue
                        })}
                        onChange={handleSectorChange}
                        styles={colourStyles}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        closeMenuOnSelect={true}
                        placeholder="Select A Job Sector"
                    />
                </div>

                {haveSector && (
                    <div className="profession-filter tw-w-full">
                        <div className="tw-flex tw-justify-around tw-items-center">
                            <label className="Form-styling tw-mb-0">Filter By Profession</label>

                            {haveProfession && (
                                <button
                                    onClick={resetProfession}
                                    className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xl tw-text-red-500"
                                >
                                    ✖
                                </button>
                            )}
                        </div>

                        {professionOptions.length > 0 ? (
                            <Select
                                closeMenuOnSelect={true}
                                placeholder="Select Professions"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                onChange={handleProfessionChange}
                                options={professionOptions}
                                styles={colourStyles}
                                value={professionOptions.filter((option) => professionValue?.includes(option.value))}
                                isClearable={false}
                                isMulti
                            />
                        ) : (
                            <div className="d-flex justify-content-center my-1">
                                <div
                                    className="spinner-grow text-primary"
                                    role="status"
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div
                                    className="spinner-grow text-secondary"
                                    role="status"
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div
                                    className="spinner-grow text-success"
                                    role="status"
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-danger" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div
                                    className="spinner-grow text-warning"
                                    role="status"
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-dark" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <div className="tw-flex tw-space-x-4 tw-justify-around tw-items-center tw-w-full">
                <div className="crm-user-filter tw-w-full">
                    <div className="tw-flex tw-justify-around tw-items-center">
                        <label className="Form-styling tw-mb-0">Filter By CRM User</label>

                        {haveOwner && (
                            <button
                                onClick={resetOwner}
                                className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xl tw-text-red-500"
                            >
                                ✖
                            </button>
                        )}
                    </div>

                    <Select
                        options={ownersOptions}
                        value={ownersOptions.filter(option => ownerValue?.includes(option.value))}
                        isClearable={false}
                        onChange={handleOwnerChange}
                        styles={colourStyles}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        closeMenuOnSelect={true}
                        placeholder="Select Lead Owners"
                        isMulti
                    />
                </div>

                <div className="user-language-filter tw-w-full">
                    <div className="tw-flex tw-justify-around tw-items-center">
                        <label className="Form-styling tw-mb-0">Filter By Language</label>

                        {haveLanguage && (
                            <button
                                onClick={resetLanguage}
                                className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xl tw-text-red-500"
                            >
                                ✖
                            </button>
                        )}
                    </div>

                    <Select
                        options={languageOptions}
                        value={languageOptions.filter(option => languageValue?.includes(option.value))}
                        isClearable={false}
                        onChange={handleLanguageChange}
                        styles={colourStyles}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        closeMenuOnSelect={true}
                        placeholder="Select Languages"
                        isMulti
                    />
                </div>


                {/* <div className="candidate-keyword-filter tw-w-full">
                    <div className="tw-flex tw-justify-around tw-items-center">
                        <label className="Form-styling tw-mb-0">Candidate Keywords</label>

                        {haveKeyword && (
                            <button
                                onClick={resetKeyword}
                                className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xl tw-text-red-500"
                            >
                                ✖
                            </button>
                        )}
                    </div>

                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter a keyword"
                        onChange={e => {
                            setHaveKeyword(true);
                            onFilterChange('candidateKeywords', e.target.value);
                        }}
                        style={{
                            borderRadius: "20px",
                            padding: "8px 16px",
                            border: "1px solid #ccc",
                            marginTop: "8px"
                        }}
                    />
                </div> */}
            </div>
        </div>
    )
}

export default CandidateFilters;